<template>
  <simulador-card :title="$t('tools.companySurroundingsTitle')">
    <simulador-field
      id="numero-funcionarios"
      :label="$t('tools.numberOfEmployees')"
      type="number"
      :value="numeroFuncionarios"
      :min="1"
      @input="updateNumeroFuncionarios"
      @change="calcularTotalPessoas"
    />
    <simulador-field
      id="total-pessoas-empresa"
      :label="$t('tools.totalPeopleCompany')"
      :value="totalPessoas"
      :formula="$t('tools.employeeQuantityFormula')"
      :is-result="true"
      style="clear: both;"
    />
  </simulador-card>
</template>

<script>
import SimuladorCard from "./SimuladorCard.vue";
import SimuladorField from "./SimuladorField.vue";

export default {
  name: "EntornoEmpresa",
  components: {
    SimuladorCard,
    SimuladorField
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        numeroFuncionarios: 450,
        totalPessoas: 450
      })
    }
  },
  computed: {
    numeroFuncionarios: {
      get() {
        return this.value.numeroFuncionarios;
      },
      set(val) {
        this.$emit("input", { ...this.value, numeroFuncionarios: val });
      }
    },
    totalPessoas: {
      get() {
        return this.value.totalPessoas;
      },
      set(val) {
        this.$emit("input", { ...this.value, totalPessoas: val });
      }
    }
  },
  methods: {
    updateNumeroFuncionarios(val) {
      this.numeroFuncionarios = val;
    },
    calcularTotalPessoas() {
      const funcionarios = parseInt(this.numeroFuncionarios) || 0;

      this.totalPessoas = funcionarios.toFixed(0);

      // Emitir evento para o componente pai com o número total de pessoas
      this.$emit("total-atualizado", funcionarios);
    }
  },
  mounted() {
    this.calcularTotalPessoas();
  }
};
</script>
